function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4d21"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4d21"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $8dbe80eee7d2c95f$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"4z5y2":"index.f1f713e7.js","dnCB2":"ios_app_qr.b4a39b7d.png","2CJz7":"icon_intel.abf50ae6.png","5lxRr":"icon_m1.7f7f8bc5.png","1ST8Z":"icon_windows_64.3c37baf1.png","01gZy":"icon_linux.bd252a86.png","VVesg":"icon_google_play.b52107b2.png","aJ7de":"icon_apple.d6a2ff35.png","czuDQ":"p_macos.95b94889.png","omoo4":"p_windows.6e768829.png","l2Qaz":"p_linux.0771d420.png","f4g5u":"p_ios.78c4754d.png","428fk":"p_android.6bab0ddd.png","a0kZn":"tutorials-1.44fc7562.png","3B6Di":"logo2.26e40c36.png","SLjkG":"logo-dots.9002424f.svg","629WQ":"product_hunt_logo.55e01c43.png","aRe47":"photoswipe.esm.1f20ad2c.js","24UWo":"full-bg-text.c1d5a921.png","2L24i":"full-bg-text_mobile.8b57c51e.png","jt4Jz":"promise-0-0.9e77bf1b.png","kCcVO":"promise-0-1.a49e7df3.png","6QgVQ":"promise-1-0.a73fcc81.png","2pnyO":"promise-1-1.4744d232.png","1Zh67":"promise-2-0.c0020086.png","kA2a9":"promise-2-1.cdcdf05d.png","dLZBe":"icon_relations.49fb7c0d.png","9bhZL":"icon_daily_plan.4d933095.png","2CJGE":"icon_journals.251f455e.png","64Mwr":"icon_data_control.2ae3325d.png","2rlxs":"benefit-0.94936967.png","hXPpN":"benefit-1.84395c1d.png","cqfdp":"benefit-2.1a4d8b56.png","hUxoi":"benefit-3.0b0e4438.png","knCKW":"logo-with-border.a30e7bd0.png","bVZ8i":"index.571e61c0.css"}'));


//# sourceMappingURL=index.5007cc62.js.map
